module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "footer"
    }
  }, [_c('span', {
    staticClass: "copy-right"
  }, [_vm._v("Zhe Jiang Wan Hang Information Technology Co.Ltd")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7e145295!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Bottom.vue
// module id = 1091
// module chunks = 0